import {
  ActivityStatusDto,
  PmcScoreDto,
  TeamEmployeeRiskLevelDto,
  TeamPlanStatusDto,
  TeamPlanStatusFilterDto,
} from '@/api/generated';
import { AreaTranslation } from '@/assets/locales/views/area/area.translation.en.ts';

export const areaTranslation: AreaTranslation = {
  alerts: {
    count_few: '{{count}} alerty',
    count_many: '{{count}} alertów',
    count_one: '{{count}} alert',
    empty: 'Brak zdarzeń wymagających uwagi w Twoim obszarze.',
    items: {
      absenceReturns: {
        subtitle: 'Powroty z długotrwałej absencji — warto zaplanować rozmowę powrotną',
        title: '{{value}} powrotów z absencji',
      },
      birthdays: {
        subtitle: 'Nadchodzące urodziny w podległym obszarze',
        title: '{{value}} urodzin',
      },
      endingContracts: {
        subtitle: 'Umowy kończące się w ciągu najbliższych 30 dni',
        title: '{{value}} kończących się umów',
      },
      headcount: {
        subtitle: 'Zmiana {{delta}} wobec stanu sprzed 2 tygodni',
        title: 'Stan zatrudnienia: {{value}}',
      },
      overdueSteps: {
        subtitle: 'Termin kroku minął, a krok nie został ukończony w aktywnym cyklu',
        title: '{{value}} pracowników z zaległymi krokami',
      },
      plansToApprove: {
        subtitle: 'Plany gotowe do realizacji, czekające na akceptację przełożonego',
        title: '{{value}} planów do akceptacji',
      },
      withoutPlan: {
        subtitle: 'Brak planu rozwoju w bieżącym cyklu',
        title: '{{value}} pracowników bez planu rozwoju',
      },
    },
    title: 'Wymagające uwagi HRBP',
  },
  hrChanges: {
    absenceReturnsScope_few: '{{count}} os. / 14 dni',
    absenceReturnsScope_many: '{{count}} os. / 14 dni',
    absenceReturnsScope_one: '{{count}} os. / 14 dni',
    chartTitle: 'Zatrudnienie — ostatnie 2 tygodnie',
    endingContractsScope_few: '{{count}} os. / 30 dni',
    endingContractsScope_many: '{{count}} os. / 30 dni',
    endingContractsScope_one: '{{count}} os. / 30 dni',
    kpi: {
      absenceReturns: 'Powroty z absencji (3+ tyg.)',
      endingContracts: 'Kończące się umowy (30 dni)',
      headcount: 'Zatrudnienie aktualne',
      headcountDelta: '{{delta}} vs 2 tyg. temu ({{previous}})',
      nearestInDays_few: 'najbliższy za {{count}} dni',
      nearestInDays_many: 'najbliższy za {{count}} dni',
      nearestInDays_one: 'najbliższy za {{count}} dzień',
      nearestToday: 'najbliższy dzisiaj',
    },
    subtitle:
      'Stan na {{date}} · zatrudnienie: 2 tyg. wstecz · umowy: 30 dni w przód · powroty: 14 dni w przód',
    title: 'Panel zmian kadrowych',
    widgets: {
      absenceReturns: 'Powroty z długotrwałej absencji',
      endingContracts: 'Kończące się umowy',
    },
  },
  hrEvents: {
    back: 'Wróć',
    chartEmpty: 'Brak danych w tym okresie.',
    chartHint: 'Kliknij słupek, aby zawęzić listę do wybranego dnia.',
    chartTooltipUnit_few: 'osoby',
    chartTooltipUnit_many: 'osób',
    chartTooltipUnit_one: 'osoba',
    dayFilter: 'Dzień: {{date}}',
    filters: {
      clear_few: 'Wyczyść ({{count}})',
      clear_many: 'Wyczyść ({{count}})',
      clear_one: 'Wyczyść ({{count}})',
      departments: 'Wszystkie działy',
      regions: 'Wszystkie regiony',
      searchPlaceholder: 'Szukaj po nazwisku lub nr SAP',
      selectedCount_few: 'Wybrano: {{count}}',
      selectedCount_many: 'Wybrano: {{count}}',
      selectedCount_one: 'Wybrano: {{count}}',
    },
    pager: {
      next: 'Dalej',
      position: 'Strona {{page}} z {{totalPages}}',
      previous: 'Wstecz',
      total_few: '{{count}} osoby',
      total_many: '{{count}} osób',
      total_one: '{{count}} osoba',
    },
    pages: {
      absenceReturns: {
        overviewLabel: 'Stan dzienny',
        title: 'Powroty z długotrwałej absencji',
      },
      birthdays: {
        overviewLabel: 'Stan dzienny',
        title: 'Urodziny zespołu',
      },
      employment: {
        overviewLabel: 'Ostatnie 2 tygodnie',
        title: 'Zatrudnienie',
      },
      endingContracts: {
        overviewLabel: 'Koniec umowy na koniec miesiąca',
        title: 'Kończące się umowy',
      },
    },
    relative: {
      inDays_few: 'za {{count}} dni',
      inDays_many: 'za {{count}} dni',
      inDays_one: 'za {{count}} dzień',
      today: 'dzisiaj',
    },
    subtitle: 'Zakres {{from}} — {{to}}',
    table: {
      department: 'Dział',
      empty: 'Brak osób spełniających kryteria.',
      eventDate: 'Data',
      externalEmployeeId: 'Nr SAP',
      person: 'Pracownik',
      position: 'Stanowisko',
      region: 'Region',
    },
    widget: {
      empty: 'Brak zdarzeń w tym okresie.',
      seeAll: 'Zobacz wszystkie',
      seeAllWithMore_few: '+ {{count}} więcej — zobacz wszystkie',
      seeAllWithMore_many: '+ {{count}} więcej — zobacz wszystkie',
      seeAllWithMore_one: '+ {{count}} więcej — zobacz wszystkie',
    },
  },
  kpi: {
    employees: 'Pracowników w obszarze',
    inDevelopmentPrograms: 'W programach rozwoju',
    managers: 'Procent managerów',
  },
  noScope: {
    description:
      'Obszar HRBP wynika z danych kadrowych: to pracownicy, przy których figurujesz jako HRBP. Obszar HRBP centrali wyznaczają reguły dostępu w panelu uprawnień. Jeśli kogoś tu brakuje, zgłoś to administratorowi.',
    title: 'Nie masz przypisanego obszaru',
  },
  people: {
    activities: {
      empty: 'Brak zapisanych aktywności rozwojowych.',
      status: {
        [ActivityStatusDto.Completed]: 'Ukończona',
        [ActivityStatusDto.InProgress]: 'W trakcie',
        [ActivityStatusDto.Planned]: 'Zaplanowana',
      },
      title: 'Aktywności rozwojowe',
    },
    badges: {
      activities: 'Aktywności rozwojowe. Kliknij, aby zobaczyć listę',
      addPanel: 'Brak zapisanego panelu rozwojowego. Kliknij, aby dodać',
      afterPanel: 'Po panelu rozwojowym',
      contractEnding: 'Koniec umowy (w ciągu 30 dni)',
      contractEndingWithDate: 'Koniec umowy {{date}} (w ciągu 30 dni)',
      longAbsence: 'Długa absencja',
      noActivities: 'Brak aktywności rozwojowych',
      noPanel: 'Brak zapisanego panelu rozwojowego',
      panels: 'Po panelu rozwojowym. Kliknij, aby zobaczyć historię',
    },
    count: '{{shown}} z {{total}} pracowników',
    empty: 'Brak wyników',
    filters: {
      departmentsAll: 'Wszystkie działy',
      departmentsLabel: 'Dział',
      planStatus: {
        [TeamPlanStatusFilterDto.All]: 'Wszystkie',
        [TeamPlanStatusFilterDto.Approved]: 'Zatwierdzony',
        [TeamPlanStatusFilterDto.None]: 'Brak planu',
        [TeamPlanStatusFilterDto.Overdue]: 'Zaległy',
        [TeamPlanStatusFilterDto.Waiting]: 'Czeka',
      },
      planStatusAll: 'Dowolny status planu',
      planStatusLabel: 'Status planu',
      pmcAll: 'Dowolna ocena PMC',
      pmcLabel: 'Ocena PMC',
      programsAll: 'Wszyscy pracownicy',
      programsLabel: 'Programy rozwoju',
      programsOnly: 'Tylko uczestnicy',
      regionsAll: 'Wszystkie regiony',
      regionsLabel: 'Region',
      risk: {
        all: 'Wszystkie',
        [TeamEmployeeRiskLevelDto.High]: 'Wysokie',
        [TeamEmployeeRiskLevelDto.Low]: 'Niskie',
        [TeamEmployeeRiskLevelDto.Medium]: 'Średnie',
      },
      riskAll: 'Dowolne ryzyko odejścia',
      riskLabel: 'Ryzyko odejścia',
      score: {
        [PmcScoreDto.Score1]: '1 · Znacznie powyżej',
        [PmcScoreDto.Score2]: '2 · Powyżej',
        [PmcScoreDto.Score3]: '3 · Zgodnie z oczekiwaniami',
        [PmcScoreDto.Score4]: '4 · Poniżej',
        [PmcScoreDto.Score5]: '5 · Znacznie poniżej',
      },
      sopAll: 'Dowolna ocena SOP',
      sopLabel: 'Ocena SOP',
      trainingsAll: 'Dowolna aktywność',
      trainingsLabel: 'Aktywności',
    },
    headers: {
      department: 'Dział / Lokalizacja',
      employee: 'Pracownik',
      plan: 'Plan%',
      pmc: 'PMC',
      risk: 'Ryzyko odejścia',
      roleTenure: 'Staż w roli',
      sop: 'SOP',
      status: 'Status planu',
    },
    loadMore: 'Pokaż więcej',
    openProfile: 'Otwórz profil',
    planStatus: {
      [TeamPlanStatusDto.Approved]: 'Zatwierdzony',
      [TeamPlanStatusDto.Draft]: 'Roboczy',
      [TeamPlanStatusDto.None]: 'Brak planu',
      [TeamPlanStatusDto.Overdue]: 'Zaległy',
      [TeamPlanStatusDto.Waiting]: 'Czeka',
    },
    programsCount: 'W programach rozwoju: {{inPrograms}} z {{total}}',
    roleTenureValue_few: '{{count}} lata',
    roleTenureValue_many: '{{count}} lat',
    roleTenureValue_one: '{{count}} rok',
    searchPlaceholder: 'Szukaj pracownika...',
    showingCount: 'Wyświetlono {{shown}} z {{total}} pracowników',
  },
  pipeline: {
    buckets: {
      from1To2Years: 'Średni horyzont (1–2 lata)',
      from3To5Years: 'Długi horyzont (3–5 lat)',
      readyNow: 'Gotowi teraz (0 mies.)',
      upTo1Year: 'Krótki horyzont (do 1 roku)',
    },
    title: 'Gotowość do awansu (Pipeline)',
    total: 'Łącznie w pipeline',
    totalValue: '{{value}} pracowników',
  },
  pmc: {
    average: 'Średnia PMC obszaru',
    empty: 'Nikt w Twoim obszarze nie ma jeszcze wyniku PMC.',
    scores: {
      [PmcScoreDto.Score1]: '1 · Znacznie powyżej',
      [PmcScoreDto.Score2]: '2 · Powyżej',
      [PmcScoreDto.Score3]: '3 · Zgodnie z oczekiwaniami',
      [PmcScoreDto.Score4]: '4 · Poniżej',
      [PmcScoreDto.Score5]: '5 · Znacznie poniżej',
    },
    title: 'Rozkład ocen PMC',
  },
  risk: {
    chips: {
      risk: {
        [TeamEmployeeRiskLevelDto.High]: 'Wysokie',
        [TeamEmployeeRiskLevelDto.Low]: 'Niskie',
        [TeamEmployeeRiskLevelDto.Medium]: 'Średnie',
      },
    },
    empty: 'Nikt w Twoim obszarze nie ma teraz podwyższonego ryzyka odejścia.',
    error: 'Nie udało się wczytać listy ryzyka odejścia. Odśwież stronę i spróbuj ponownie.',
    loadMore: 'Pokaż więcej',
    peopleCount: '{{count}} osób',
    riskTitle: 'Ryzyko odejścia',
    showingCount: 'Wyświetlono {{shown}} z {{total}} osób',
  },
  stats: {
    adminView: 'Przeglądasz jako: Admin',
    backToStart: 'Wróć na Start',
    everyoneView: 'Przeglądasz: wszyscy pracownicy',
    sectionTitle: 'Potencjał i ryzyko obszaru',
  },
  tabs: {
    dashboard: 'Dashboard HRBP',
    hrChanges: 'Zmiany kadrowe',
    matrix: 'Macierz zespołu',
    people: 'Pracownicy',
    peopleWithCount: 'Pracownicy ({{value}})',
    risk: 'Ryzyko odejścia',
  },
};
